module.exports = __webpack_public_path__ + "0647a24dd74cc5e7486a37d13b7f057c.svg";